import React from "react";

export const MenuItem = ({ key, children, onClick, selected }) => {
  return (
  	<li key={key} className={`menuItem ${selected && 'menuItemSelected'}`} onClick={onClick}>
			{children}
		</li>
  );
};
